import React from "react";
import { X } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const SOURCE_LABELS = {
  OPER: "OPER",
  GENDETAILED_PROD: "GEN",
  IC385DETAIL: "IC1",
  IC385P2DETAIL: "IC2",
  TE350: "TE",
  TIME_CLOCK_YEARLY: "TC-A",
  TIME_CLOCK_MONTH: "TC-M",
};

/**
 * AliasBadge — pill that shows a single (code, source_report) alias for a
 * canonical employee. The X button is only rendered in editable contexts.
 */
export default function AliasBadge({ alias, onRemove, editable }) {
  const label = SOURCE_LABELS[alias.source] || alias.source;
  return (
    <Badge
      variant="outline"
      className="gap-1 font-mono text-[10px]"
      data-testid={`alias-${alias.code}-${alias.source}`}
    >
      <span>{alias.code}</span>
      <span className="text-muted-foreground">· {label}</span>
      {editable && (
        <button
          onClick={onRemove}
          className="ml-1 rounded-sm text-muted-foreground hover:text-destructive"
          data-testid={`alias-remove-${alias.code}-${alias.source}`}
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </Badge>
  );
}
